export const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload) as { [key: string]: string | number };
};

export const isJwtExpired = (token: string): boolean => {
  try {
    const { exp } = parseJwt(token);
    if (typeof exp !== 'number') return false;
    return Date.now() >= exp * 1000;
  } catch {
    return true;
  }
};
